// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBottomBtn {
    position: fixed;
    bottom: 98px;
    right: 0;
    z-index: 12;
    background-color: black;
    color: white;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    font-size: 14px;
    text-align: center;
}

::ng-deep .latestNode{
    fill: red;
    stroke: green;
}

.fa-external-link-alt {
    text-align: center;
    position: absolute;
    top: 41%;
    left: 48%;
    height: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    display: block;
}

.footer-title-input {
    border-top: none;
    border-left: none;
    border-radius: 0;
    border-right: none;
    background-color: transparent;
    color: #ffffff;
}

.footer-title-input:focus {
    background-color: transparent;
    color: #ffffff;
}

section.vid-publish-footer {
    padding-block: 15px !important;
}


/* Start */
.chart-container {
    position: relative;
    width: 100%;
    height: 100vh;
    padding: 20px;
    box-sizing: border-box;
}

.chart-container .visible-block {
    width: 100%;
    height: calc(100% - 13rem);
    /*border: 2px solid #198754;
    border-radius: 8px;*/
    overflow: hidden;
    background: #fff;
}

.chart-container .svg-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.chart-container .chart-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
}


.controls-container {
    position: fixed;
    bottom: 120px;
    right: 22px;
    align-items: flex-end;
    background: white;
    /* border-radius: 5px; */
    box-shadow: 0 2px 10px rgba(128, 128, 128, 0.1);
    /*border: 1px solid #6c2fbb;*/
    
}
.controls-container .bottom-action {
    position: absolute;
    bottom: unset;
    top: -36px;
    right: 0;
    background: #e9effd;
    border-radius: 0px; 
    border: 0px solid #cccccc;
}
.controls-container .bottom-action img {
    filter: brightness(0);
}

.controls-container .minimap-container {
    /*border-bottom: 2px solid #c2c8d6;*/
    width: 100%;
    overflow: hidden;
}
.zoom-controls {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 20;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px;
    width: 150px;
        border: 1px solid #6c2fbb;
  }

.zoom-controls .zoom-percent {
    align-content: center;
    padding: 6px 12px;
    border: 2px solid transparent;
    border-radius: 10px;
}

.zoom-controls .zoom-percent:hover {
    border: 2px solid #1d4ed8;
    border-radius: 10px;
}

.zoom-controls button {
    flex: 1;
    padding: 0px 6px;
    border: 2px solid transparent;
    border-radius: 10px;
    background: white;
    cursor: pointer;
}

.zoom-controls button:hover {
    border: 2px solid #1d4ed8;
    border-radius: 6px;
}

.context-menu {
    position: absolute;
    display: none;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    padding: 8px;
    z-index: 1000;
    transform: translate(-50%, -100%);
    margin-top: -10px;
}

.context-menu .menu-item {
    display: inline-block;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 4px;
    margin: 0 4px;
}

.context-menu .menu-item:hover {
    background-color: #f0f0f0;
}

.context-menu .menu-item i {
    font-size: 16px;
}

.context-menu .menu-item i.fa-edit {
    color: #2196f3;
}

.context-menu .menu-item i.fa-trash {
    color: #f44336;
}

.context-menu .menu-item i.fa-info-circle {
    color: #4caf50;
}

.context-menu .menu-item:first-child {
    margin-left: 0;
}

.context-menu .menu-item:last-child {
    margin-right: 0;
}

.icon {
    transition: opacity 0.2s ease-in-out, fill 0.2s ease-in-out;
    opacity: 0;
}

.icon:hover {
    fill: #2196f3;
}

.timer-icon:hover {
    fill: #ff9800;
}

.notes-icon:hover {
    fill: #4caf50;
}

.dragging {
    cursor: grabbing !important;
}

.dragging rect {
    filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.3));
    stroke: #666;
    stroke-width: 2px;
}

.dragging text {
    font-weight: bold;
}

.node-group {
    cursor: pointer;
}

.node-group.dragging {
    opacity: 0.7;
    cursor: grabbing;
}

.node-group:hover rect {
    stroke: #666;
    stroke-width: 2px;
}

.drag-node {
    pointer-events: none;
}

.drag-node text {
    font-size: 12px;
    fill: #333;
}

.node-context-menu {
    position: absolute;
    display: none;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    transform: translate(-50%, 0%);
    margin-top: -10px;
    border: 1px solid #8080802e;
    transition: opacity 0.2s ease;
}

.node-context-menu .menu-item {
    padding: 6px 10px;
    cursor: pointer;
    transition: all 0.2s;
    /* border-radius: 4px; */
    border-bottom: 1px solid #8080802e;
    display: flex;
    align-items: center;
    gap: 4px;
}

.node-context-menu .menu-item:last-child {
    border-bottom: none;
}

.node-context-menu .menu-item:hover {
    background-color: #f0f0f0;
}

.node-context-menu .menu-item i {
    font-size: 16px;
}

.node-context-menu .menu-item i.fa-edit {
    color: #2196f3;
}

.node-context-menu .menu-item i.fa-trash {
    color: #f44336;
}

.node-context-menu .menu-item i.fa-info-circle {
    color: #4caf50;
}

.node-context-menu .menu-item:first-child {
    margin-left: 0;
}

.node-context-menu .menu-item:last-child {
    margin-right: 0;
}

.zoom-input-container {
    align-content: center;
}

.zoom-input {
    width: 55px;
    text-align: right;
    border: none;
    padding: 0px 6px;
}

.zoom-input:hover,
.zoom-input:focus-visible {
    border: 2px solid #1d4ed8;
    border-radius: 6px;
}

.example-full-width {
    width: 100%;
}

.add-pathways-container {
    height: 82%;
    width: 460px;
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 5px;
}

.add-pathways-container .path-img {
    border-radius: 13px;
    max-height: 250px;
    width: 100%;
}

.civ-message .msg-description {
    overflow-wrap: anywhere;
}

.civ-message-body {
    display: flex;
}

.civ-message-body.from {
    justify-content: flex-start;
}

.civ-message-body.to {
    justify-content: flex-end;
}

.civ-message {
    display: inline-block;
    border-radius: 1.5rem;
    margin-bottom: 15px;
    padding: 8px 20px;
    position: relative;
    /*font-size: 20px;*/
}

.civ-message-body.to .civ-message {
    background-color: #9b4dca;
    color: #fff;
    margin-left: 100px;
    width: 200px;
}

.civ-message .type-image {
    width: 100px;
}

.civ-message-body.from .civ-message {
    background-color: #E5E4E9;
    color: #363636;
    margin-right: 100px;
}

.civ-message-body.to+.civ-message-body.to,
.civ-message-body.from+.civ-message-body.from {
    margin-top: -10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion .list-group {}

.civ-message-suggestion .list-group-item {
    padding: 0.5rem;
}

.civ-message-suggestion .choice {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}

.objectImg img {
    height: 40px;
}

.objectImg span i {
    font-size: 18px;
    cursor: pointer;
    color: #6c6c6c;
}

.civ-message .type-image {
    width: 100px;
}

.civ-message .msg-description {
    overflow-wrap: anywhere;
}

.objectives {
    width: 300px;
    position: relative;
    margin: 11px 0 0 0;
}

.objectives input {
    margin: 0px;
    padding: 0px;
    width: 100%;
    outline: none;
    height: 40px;
    border-radius: 5px;
    border: none;
    padding: 0 0 0 5px;
}

.objectives button {
    position: absolute;
    top: 0;
    right: -2px;
    z-index: 2;
    border: none;
    top: 0;
    height: 40px;
    cursor: pointer;
    transform: translateX(2px);
    width: 36px;
}

.objectives i {
    font-size: 18px;
    line-height: 2;
    color: #6c6c6c;
}

.objectImg img {
    height: 40px;
}

.objectImg span i {
    font-size: 18px;
    cursor: pointer;
    color: #6c6c6c;
}

.objectivesButtons .btnDone {
    background: #9b4dca;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.objectivesButtons .btnCancel {
    background: #6c6c6c;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.show-objectives {
    width: 100%;
    height: 40px;
    position: relative;
    margin: 11px 0 0 0;
    background-color: white;
    color: #6c6c6c;
    overflow-wrap: anywhere;
    overflow: auto;
    padding: 0 5px;
}

.objectivesButtons .btnDone {
    background: #9b4dca;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.objectivesButtons .btnCancel {
    background: #6c6c6c;
    color: white;
    padding: 0 5px;
    font-size: 15px;
    margin-left: 5px;
}

.pathways-colors {
    margin: 0px 5px 10px;
    width: 60px;
    height: 30px;
    border-radius: 10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion .list-group {}

.civ-message-suggestion .list-group-item {
    padding: 0.5rem;
}

.civ-message-suggestion .choice {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}

.civ-message-suggestion .list-group {}

.civ-message-suggestion .list-group-item {
    padding: 0.5rem;
}

.civ-paths-btn {
    display: inline-flex;
    align-items: center;
    background: rgba(100, 56, 180, 0.05);
    border: 1px solid #6438B4;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    color: #6438B4;
    padding: 0 16px;
    margin: 5px;
    min-height: 50px;
    position: relative;
}

.civ-paths-btn i {
    display: none;
    cursor: pointer;
    margin-right: -5px;
    margin-left: 5px;
}

.civ-paths-btn:hover i {
    display: inline-block;
}

.popup-objective {
    z-index: 1;
    position: absolute;
    background: white;
    padding: 0 7px;
    border-radius: 6px;
    width: -moz-fit-content;
    width: fit-content;
    top: 52px;
    right: 0;
    width: 200px;
    height: 210px;
    overflow: auto;
}

.objective-img {
    height: 48px;
    display: flex;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
}

.popup-objective ul {
    text-align: start;
    padding-left: 25px;
}

.popup-objective li {
    margin-top: 10px;
}

::ng-deep #node .active {
    fill: #ffb46e !important;
}

.contibutorsTabs p {
    margin: 0;
    font-size: 17px;
    cursor: pointer
}

.activeTab {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.sharing-modal-body {
    padding: 15px;
}

.collabeBody {
    height: 325px !important;
    overflow-x: hidden;
    overflow-y: scroll;
}

.sharing-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
    /* margin-top: 40px; */
    margin-bottom: 40px;
}

.sharing-links li {
    display: inline-block;
    margin-right: 40px;
    cursor: pointer;
}

.user-list-item {
    width: 100%;
    text-align: left;
    margin-right: 30px;
}

.sharing-links li img {
    width: 50px;
    height: 50px;
}

.sharing-links li p {
    font-size: 12px;
    color: #a6a3a3;
}

.follower-name {
    margin-left: 10px;
}

.collabeImg {
    border-radius: 7px;
    width: 30px !important;
    height: 30px !important;
    margin-right: 4px;
    margin-top: -7px;
}

.custom-footer button.modal-btn {
    background-color: #6e5eff;
    color: #fff;
    border-radius: 4px;
    padding: 5px 15px;
}

.custom-footer button.modal-btn-close {
    background-color: #605f5f;
    color: #fff;
    border-radius: 4px;
    padding: 10px 23px;
}

.node-context-menu .menu-item {
    font-size: 12px;
}

.tree-Modal .tree-card-content .vid-select select {
    width: 100%;
    border-bottom: 1px solid #5c5c5c;
    border-radius: 0;
    margin-bottom: 10px;
    font-size: 15px;
}

.tree-Modal .tree-card-content .opts-row button img {
    width: 20px;
    height: 20px;
}

.tree-Modal .tree-card-vid .leave-btn,
.tree-Modal .tree-card-vid .more-btn {
    position: absolute;
    top: 8px;
    z-index: 99;
}
.more-btn .dropdown-menu {
    min-width: auto;
}
/*.video-card {*/
/*  cursor: pointer;*/
/*}*/

.tree-Modal .tree-card-vid .leave-btn {
    left: 14px;
    color: #ffffff;
    opacity: 1;
    font-weight: 400;
    font-size: 16px;
}

.tree-Modal .tree-card-vid .more-btn {
    right: 8px;
}

.tree-Modal .tree-card-content .check-line span {
    width: 20px;
    height: 20px;
    border: 1px solid black;
    display: inline-block;
    margin-right: 8px;
}

.tree-Modal .tree-card-content .check-line input {
    color: #000;
    margin-left: 10px;
    border: 0px;
    width: 6vw;
    border-bottom: 1px solid #ccc;
    font: 400 14px/20px Roboto, "Helvetica Neue", sans-serif;
}

.tree-Modal .tree-card-content .check-line label {
    cursor: pointer;
    font-size: 15px;
}

.tree-Modal .tree-card-content .check-line input:checked+label:after {
    content: "";
    position: absolute;
    left: 22px;
    top: 5px;
    width: 6px;
    height: 14px;
    border: solid #6e5eff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.tree-Modal .tree-card-vid video {
    outline: none;
}

.close {
    font-weight: normal !important;
}

.tree-Modal .tree-card-vid .leave-btn,
.tree-Modal .tree-card-vid .more-btn {
    position: absolute;
    top: 8px;
    z-index: 99;
}

.tree-Modal .tree-card-vid .leave-btn {
    left: 14px;
    color: #ffffff;
    opacity: 1;
    font-weight: 400;
    font-size: 16px;
}

input.close.leave-btn {
    background: transparent;
    border: none;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    text-align: center;
    width: 100%;
    margin-left: 0px;
}

.title-center {
    float: none;
    margin-left: 90px;
}

.preview-image-none {
    font-size: 22px;
    background: #e1e1e1;
    height: 300px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-image {
    width: 100%;
    height: auto;
    max-height: 300px;
    cursor: pointer;
    object-fit: contain;
}

.chcoice {
    font-size: 14px;
    margin-top: 10px;
}

.add-choices input {
    width: 60px;
    display: inline-block;
}

.addChoiceDropDown .dropdown-menu {
    min-width: 8.2rem;
    padding: 0 !important;
}

.addChoiceDropDown .dropdown-menu .dropdown-item {
    font-size: 14px;
}

.addChoiceDropDown .dropdown-item:focus,
.addChoiceDropDown .dropdown-item:hover {
    background-color: rgb(241 234 254) !important;
    color: #6c2fbb !important;
}

.addChoiceDropDown .dropdown-item.active,
.addChoiceDropDown .dropdown-item:active {
    background-color: inherit;
    color: inherit;
}

.choice-btn {
    border: 1px solid #6e5eff;
    padding: 5px 15px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    display: inline-block;
    cursor: pointer;
    position: relative;
    outline: none;
    border-left: 0;
    height: -moz-fit-content;
    height: fit-content;
    /* margin: 0 0px 0 4px; */
    /* max-width: 99.2% !important; */
}

.dropdown-menus {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
}

.dropdown-menu ul {
    list-style: none;
    padding-left: 0px;
}

.dropdown-menu ul li {
    border-bottom: 1px solid #80808094;
    padding-left: 11px;
    margin-top: 7px;
    color: #605f5f;
    font-size: 12px;
}

.dropdown-menu .form-control {
    margin-top: 11px;
    border-radius: 0;
    padding: 5px;
    outline: none;
}

.dropdown-menu {
    min-width: 22.4rem;
    top: -277px;
}

.dropdown-menu [type="checkbox"] {
    width: 35px;
    height: 15px;
}

.addChoiceDropDown .dropdown-menu {
    min-width: 8.2rem;
    padding: 0 !important;
}

.addChoiceDropDown .dropdown-menu .dropdown-item {
    font-size: 14px;
}

.chexk-box-top {
    width: 100%;
    margin: 5px;
}

.userPromptSection {
    padding-right: 25px;
    padding-left: 5px;
}

.userPromptSection input {
    border-bottom: 1px solid #cccccc !important;
}

.nodeTitleInput {
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    padding-bottom: 5px;
    width: 100%;
}

.nodeTitleInput:focus {
    border-bottom: 1px solid #ccc;
}

.dropdownWidth {
    padding-right: 4px !important;
    padding-left: 4px !important;
}

.option-choices {
    margin-bottom: 15px;
}

.option-choices.draggable {
    cursor: move;
    border: 1px dashed #dc3545;
}

.nodeTitleInput {
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    padding-bottom: 5px;
    width: 100%;
}

.nodeTitleInput:focus {
    border-bottom: 1px solid #ccc;
}

.find-peoples-sec .search-area .share-btn {
    width: 100%;
    background: #6e5eff;
    color: #ffffff;
}

.find-peoples-sec .search-area .search button {
    position: absolute;
}

.find-peoples-sec .search-area .search input {
    padding-left: 40px;
    font-size: 15px;
}

.find-peoples-sec .select-area .FF-scroll-modify {
    height: 133px;
}

.find-peoples-sec .select-area .form-check {
    margin-bottom: 14px;
}

.find-peoples-sec .select-area .form-check span {
    display: inline-block;
    width: 35px;
    height: 35px;
    border: 1px solid #e6e3e3;
    border-radius: 50%;
    margin-right: 10px;
}

.find-peoples-sec .select-area .form-check input {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    margin-left: 0px;
}

.find-peoples-sec .select-area .form-check span img {
    width: 100%;
    height: 100%;
}

.find-peoples-sec .select-area .form-check input:checked+label {
    color: #6e5eff;
}

.find-peoples-sec .select-area .form-check input:checked+label:after {
    content: "";
    position: absolute;
    left: 13px;
    top: 8px;
    width: 10px;
    height: 17px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

.find-peoples-sec .select-area .form-check input:checked+label:before {
    content: "";
    width: 35px;
    height: 35px;
    background-color: #6e5effcc;
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 50%;
}

.find-peoples-sec .search-area h6.count-selected {
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 0px;
    color: #919191;
}

.w-qus {
    width: 3.2rem;
    height: 3.2rem;
}

.timer-button {
    background: #6e5eff;
    border-color: #6e5eff;
    color: white;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
}

.create-interactive-button {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    display: block;
    /*margin: 0 auto;*/
    cursor: pointer;
    position: relative;
    outline: none;
    margin: 4px 0 4px 4px;
}

/* ::ng-deep .nodeImage {
    width: 182px;
    height: 130px;
} */


.tree-share-Modal,
.tree-preview-vid-Modal,
.tree-publish-vid-Modal {
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.tree-share-Modal .modal-body,
.tree-share-Modal .modal-header,
.tree-preview-vid-Modal .modal-body,
.tree-preview-vid-Modal .modal-header,
.tree-publish-vid-Modal .modal-body,
.tree-publish-vid-Modal .modal-header {
    padding: 20px 25px 25px 25px;
}

.tree-share-Modal .modal-title,
.tree-preview-vid-Modal .modal-title,
.tree-publish-vid-Modal .modal-title {
    font-size: 18px;
    font-weight: 600;
}

.tree-publish-vid-Modal .publish-vid-sec .signup-group {
    position: relative;
    margin-bottom: 15px;
}

.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) label {
    top: 5px;
    left: 0;
}

.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) textarea {
    padding: 15px 10px 10px 10px;
    height: 150px;
    resize: none;
}

.tree-publish-vid-Modal .publish-vid-sec h5 {
    font-size: 17px;
    margin-bottom: 0px;
    margin-top: 1rem;
}

.mat-hint {
    font-size: 0.7rem;
}

.tree-publish-vid-Modal .publish-vid-sec p {
    font-size: 12px;
    color: #605f5f;
}

.tree-publish-vid-Modal .publish-vid-sec select {
    font-size: 14px;
}

.publish-vid-sec .info-radio .select-radio {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 15px;
}

.publish-vid-sec .info-radio .select-radio input {
    opacity: 0;
}

.publish-vid-sec .info-radio .select-radio .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 22px;
    border: 1px solid black;
    border-radius: 50%;
}

.publish-vid-sec .info-radio .select-radio input:checked+.checkmark:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    height: 10px;
    width: 10px;
    background-color: #6e5eff;
    border-radius: 50%;
}

.find-peoples-sec .search-area h6.count-selected {
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 0px;
    color: #919191;
}

/* Tree chart select & share Modal */

/* Tree Chart video preview Modal */

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {
    font-size: 17px;
    margin-bottom: 0px;
    margin-top: 1rem;
}

.tree-preview-vid-Modal .preview-vid .vid-txt>.row {
    align-items: center;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {
    font-size: 15px;
    color: black;
    padding: 8px 0px;
    border-radius: 6px;
    transition: all 0.2s linear;
    width: 150px;
    border: 1px solid #ccc;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {
    background-color: #6e5eff;
    color: #ffffff;
}

.optionsOFchoice {
    background: #000;
    z-index: 9;
    position: relative;
    display: table;
    width: 100%;
    text-align: center;
}

.optionschoiceitem {
    padding: 20px 10px;
    font-size: 16px;
    /* border-radius: 5px; */
    color: #fff;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    border-right: 1px solid #fff;
    display: table-cell;
    word-break: break-all;
}

.optionschoiceitem:hover {
    color: #726bfa;
}

/* Connector Node Link Definition */
/*::ng-deep .link {
    fill: auto !important; 
    stroke: red !important;
    stroke-width: 2px;
}*/

::ng-deep .link {
    fill: auto;
    /* Allow fill inheritance */
    stroke: red;
    stroke-width: 2px;
}

.publish-vid .thumbnail-area .row>div {
    padding-left: 5px;
    padding-right: 5px;
}

.publish-vid .thumbnail-area .select-thumb {
    position: relative;
    cursor: pointer;
    height: 60px;
    margin-top: 10px;
}

.publish-vid .thumbnail-area .select-thumb.up {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dotted;
}

.publish-vid .thumbnail-area .select-thumb input {
    display: none;
}

.publish-vid .thumbnail-area .select-thumb .upload img {
    width: 20px;
    height: 20px;
}

.publish-vid .thumbnail-area .select-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.publish-vid .thumbnail-area .select-thumb input:checked~.check {
    width: 100%;
    height: 100%;
    background-color: #6e5effcc;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.publish-vid .thumbnail-area .select-thumb input:checked~.check:before {
    content: "";
    width: 7px;
    height: 14px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

.publish-vid .thumbnail-area .select-thumb img.deletrThumnails {
    width: 30px;
    height: auto;
    /* margin-top: -43px; */
    text-align: center;
    margin-top: 5px;
    padding: 5px;
}

.publish-vid .thumbnail-area .select-thumb img.deletrThumnails:hover {
    background: #ccc;
}

.publish-vid-btn {
    bottom: 0px;
    right: 16px;
}

.publish-vid-btn button {
    font-size: 15px;
    color: black;
    padding: 8px 0px;
    border-radius: 6px;
    transition: all 0.2s linear;
    width: 140px;
    border: 1px solid #ccc;
    background-color: #6e5eff;
    color: #ffffff;
}

.newContentTree {
    background: #6c2fbbb8;
    color: white;
    padding: 10px 20px;
}

.newContentTree .btn-close {
    filter: brightness(0) invert(1);
    box-shadow: none;
    opacity: 1;
    padding: 0;
}

.newContentTree .info-img {
    filter: brightness(0) invert(1);
    margin-top: 8px;
}

.newContentTree h6 {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 0;
}

.newContentTree .btn-light {
    font-size: 14px;
    padding: 4px 8px;
}

.newContentTree a {
    text-decoration: underline;
    color: white
}

.newContentTree p {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
}

.updateAiKeyInsightsDialog label {
    font-size: 15px;
}

.key-insight-group {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 15px;
    padding-bottom: 15px;
}

.key-insight-box {
    background: rgb(108 47 187 / 10%);
    padding: 15px 10px;
    border-radius: 8px;
    position: relative;
}

.remove-category {
    width: 25px;
    height: 25px;
    background-color: #e85959;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 6px;
    right: 6px;
    border-radius: 5px;
    cursor: pointer;
}

.visibility-switch .form-check-input {
    box-shadow: none;
    width: 50px;
    height: 25px;
    margin: 0;
    cursor: pointer;
    border-color: #6c2fbb !important;
    background-image: url('switch-focus.svg') !important;
}

.visibility-switch .form-check-input:checked {
    background-color: #6c2fbb;
    background-image: url('switch-check.svg') !important;
}

/* < !-- PS Changes --> */
.btnKeyInsight {
    filter: brightness(0) invert(1);
}

.btnEditIcon {
    border: 1px solid #f8f9fa;
    height: 32px
}
.choiceNameInput{
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    padding-bottom: 5px;
    width: 100%;
}

.choiceNameInput:focus {
    border-bottom: 1px solid #ccc;
    border-radius: 0;
}

::ng-deep .my-dialog-edit {
    justify-content: center;
}

::ng-deep .my-dialog-edit .mdc-dialog__container {
    margin: auto;
}

::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {
    visibility: hidden;
}

.choice-bulb {
    background-color: #7a2df9;
    width: 26px;
    height: 26px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.choices-box {
    box-shadow: 0 0 7px 2px rgba(0, 0, 0, 0.07);
    padding: 10px 15px;
    border-radius: 10px;
}

.bulkEditBtn{
    width: 220px !important;
}
.bulkChoiceModel .modal-content {
    position: relative;
}
.bulkChoiceModel .modal-content::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
}

#suggest-choice-name-modal .choices-box p {
    font-size: 15px;
}
#suggest-choice-name-modal .active {
    background: rgba(122, 45, 249, 0.1);
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
}

.aiSuggestion{
    display: inline-block;
}
.videoNameCls{
    margin-bottom: 0 !important;
}

.close-purple {
    display: flex;
    margin-right: 4px;
}
.close-purple .btn-close {
    opacity: 1;
    background-size: 10px;
}

.bottom-action {
    width: 35px;
    height: 35px;
    border-radius: 100%;
    /* background-color: #6c2fbb; */
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 25px;
    right: 64px;
    cursor: pointer;
    z-index: 9;
}
.bottom-action img {
    transition: all 0.2s;
    filter: brightness(0);
}
.bottom-action.hide-section img {
    rotate: 180deg;
    filter: unset;
}

.hide-section-minimap{
    rotate: 180deg;
    filter: unset;
}

@media (max-width: 1034px) {
    .tree-Modal .tree-card-content .check-line input {
        width: 20vw;
    }
}

@media (max-width: 565px) {
    .tree-Modal .tree-card-content .userPromptSection>div:first-child {
        flex-direction: column;
        gap: 0 !important;
        margin-bottom: 10px;
        margin-top: 5px;
        font-size: 15px;
    }

    .tree-Modal .tree-card-content .userPromptSection>div:last-child i {
        vertical-align: bottom;
    }
}

@media (max-width: 576px) {
    .vid-options {
        margin-top: 10px !important;
    }

    .dropdown-menu {
        min-width: 15.4rem !important;
    }
}

@media (max-width: 991px) {
    section.vid-publish-footer {
        padding-block: 8px !important;
    }
    .tree-view-chart-sec {
        padding: 0px 26px !important;
    }

    .select-video {
        width: auto !important;
        padding: 20px !important;
    }

    .uploadVideoButton {
        width: auto !important;
        padding: 20px !important;
    }

    .dropdown-menu {
        min-width: 15.4rem !important;
    }
}

@media (max-width: 767px) {
    .bottom-action {
        bottom: 82px;
        right: 35px;
    }
    .vid-publish-footer .row .footer-text {
        margin-bottom: 0 !important;
    }
}
@media (max-width: 434px) {
    .tree-Modal .tree-card-content .chexk-box-top label {
        width: 100%;
        margin-bottom: 6px !important;
        font-size: 15px;
    }

    .tree-Modal .tree-card-content .mat-card-title-group .mat-card-sm-image {
        width: 50px;
        height: 50px;
    }

    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleChoice {
        padding-left: 7px !important;
    }

    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleEdit,
    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleUpload {
        padding-inline: 0 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/new-create-video/new-create-inter-active-video/new-create-inter-active-video.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;;AAGA,UAAU;AACV;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B;wBACoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;IACxB,+CAA+C;IAC/C,6BAA6B;;AAEjC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,YAAY;QACR,yBAAyB;EAC/B;;AAEF;IACI,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2DAA2D;IAC3D,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mDAAmD;IACnD,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,qCAAqC;;AAErC;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,qCAAqC;;AAErC;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,qCAAqC;;AAErC;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA,gBAAgB;AAChB,qBAAqB;AACrB,IAAI;;AAEJ;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,wBAAmB;IAAnB,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;;;GAGG;;;AAGH;;;IAGI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;;;;;IAMI,4BAA4B;AAChC;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA,oCAAoC;;AAEpC,mCAAmC;;AAEnC;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,wBAAwB;IACxB,yBAAyB;IACzB,8CAA8C;IAC9C,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;;;;EAIE;;AAEF;IACI,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,oDAAiF;AACrF;;AAEA;IACI,yBAAyB;IACzB,oDAAiF;AACrF;;AAEA,yBAAyB;AACzB;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB;AACJ;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;AACd;AACA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,WAAW;QACX,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;QAEI,4BAA4B;IAChC;AACJ","sourcesContent":[".topBottomBtn {\n    position: fixed;\n    bottom: 98px;\n    right: 0;\n    z-index: 12;\n    background-color: black;\n    color: white;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    font-size: 14px;\n    text-align: center;\n}\n\n::ng-deep .latestNode{\n    fill: red;\n    stroke: green;\n}\n\n.fa-external-link-alt {\n    text-align: center;\n    position: absolute;\n    top: 41%;\n    left: 48%;\n    height: 50%;\n    transform: translate(-50%, -50%);\n    width: 10px;\n    height: 10px;\n    display: block;\n}\n\n.footer-title-input {\n    border-top: none;\n    border-left: none;\n    border-radius: 0;\n    border-right: none;\n    background-color: transparent;\n    color: #ffffff;\n}\n\n.footer-title-input:focus {\n    background-color: transparent;\n    color: #ffffff;\n}\n\nsection.vid-publish-footer {\n    padding-block: 15px !important;\n}\n\n\n/* Start */\n.chart-container {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.chart-container .visible-block {\n    width: 100%;\n    height: calc(100% - 13rem);\n    /*border: 2px solid #198754;\n    border-radius: 8px;*/\n    overflow: hidden;\n    background: #fff;\n}\n\n.chart-container .svg-container {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.chart-container .chart-content {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n\n.controls-container {\n    position: fixed;\n    bottom: 120px;\n    right: 22px;\n    align-items: flex-end;\n    background: white;\n    /* border-radius: 5px; */\n    box-shadow: 0 2px 10px rgba(128, 128, 128, 0.1);\n    /*border: 1px solid #6c2fbb;*/\n    \n}\n.controls-container .bottom-action {\n    position: absolute;\n    bottom: unset;\n    top: -36px;\n    right: 0;\n    background: #e9effd;\n    border-radius: 0px; \n    border: 0px solid #cccccc;\n}\n.controls-container .bottom-action img {\n    filter: brightness(0);\n}\n\n.controls-container .minimap-container {\n    /*border-bottom: 2px solid #c2c8d6;*/\n    width: 100%;\n    overflow: hidden;\n}\n.zoom-controls {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    z-index: 20;\n    background: white;\n    border-radius: 5px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding: 8px;\n    width: 150px;\n        border: 1px solid #6c2fbb;\n  }\n\n.zoom-controls .zoom-percent {\n    align-content: center;\n    padding: 6px 12px;\n    border: 2px solid transparent;\n    border-radius: 10px;\n}\n\n.zoom-controls .zoom-percent:hover {\n    border: 2px solid #1d4ed8;\n    border-radius: 10px;\n}\n\n.zoom-controls button {\n    flex: 1;\n    padding: 0px 6px;\n    border: 2px solid transparent;\n    border-radius: 10px;\n    background: white;\n    cursor: pointer;\n}\n\n.zoom-controls button:hover {\n    border: 2px solid #1d4ed8;\n    border-radius: 6px;\n}\n\n.context-menu {\n    position: absolute;\n    display: none;\n    background: white;\n    border-radius: 4px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    padding: 8px;\n    z-index: 1000;\n    transform: translate(-50%, -100%);\n    margin-top: -10px;\n}\n\n.context-menu .menu-item {\n    display: inline-block;\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: all 0.2s;\n    border-radius: 4px;\n    margin: 0 4px;\n}\n\n.context-menu .menu-item:hover {\n    background-color: #f0f0f0;\n}\n\n.context-menu .menu-item i {\n    font-size: 16px;\n}\n\n.context-menu .menu-item i.fa-edit {\n    color: #2196f3;\n}\n\n.context-menu .menu-item i.fa-trash {\n    color: #f44336;\n}\n\n.context-menu .menu-item i.fa-info-circle {\n    color: #4caf50;\n}\n\n.context-menu .menu-item:first-child {\n    margin-left: 0;\n}\n\n.context-menu .menu-item:last-child {\n    margin-right: 0;\n}\n\n.icon {\n    transition: opacity 0.2s ease-in-out, fill 0.2s ease-in-out;\n    opacity: 0;\n}\n\n.icon:hover {\n    fill: #2196f3;\n}\n\n.timer-icon:hover {\n    fill: #ff9800;\n}\n\n.notes-icon:hover {\n    fill: #4caf50;\n}\n\n.dragging {\n    cursor: grabbing !important;\n}\n\n.dragging rect {\n    filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.3));\n    stroke: #666;\n    stroke-width: 2px;\n}\n\n.dragging text {\n    font-weight: bold;\n}\n\n.node-group {\n    cursor: pointer;\n}\n\n.node-group.dragging {\n    opacity: 0.7;\n    cursor: grabbing;\n}\n\n.node-group:hover rect {\n    stroke: #666;\n    stroke-width: 2px;\n}\n\n.drag-node {\n    pointer-events: none;\n}\n\n.drag-node text {\n    font-size: 12px;\n    fill: #333;\n}\n\n.node-context-menu {\n    position: absolute;\n    display: none;\n    background: white;\n    border-radius: 4px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    transform: translate(-50%, 0%);\n    margin-top: -10px;\n    border: 1px solid #8080802e;\n    transition: opacity 0.2s ease;\n}\n\n.node-context-menu .menu-item {\n    padding: 6px 10px;\n    cursor: pointer;\n    transition: all 0.2s;\n    /* border-radius: 4px; */\n    border-bottom: 1px solid #8080802e;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.node-context-menu .menu-item:last-child {\n    border-bottom: none;\n}\n\n.node-context-menu .menu-item:hover {\n    background-color: #f0f0f0;\n}\n\n.node-context-menu .menu-item i {\n    font-size: 16px;\n}\n\n.node-context-menu .menu-item i.fa-edit {\n    color: #2196f3;\n}\n\n.node-context-menu .menu-item i.fa-trash {\n    color: #f44336;\n}\n\n.node-context-menu .menu-item i.fa-info-circle {\n    color: #4caf50;\n}\n\n.node-context-menu .menu-item:first-child {\n    margin-left: 0;\n}\n\n.node-context-menu .menu-item:last-child {\n    margin-right: 0;\n}\n\n.zoom-input-container {\n    align-content: center;\n}\n\n.zoom-input {\n    width: 55px;\n    text-align: right;\n    border: none;\n    padding: 0px 6px;\n}\n\n.zoom-input:hover,\n.zoom-input:focus-visible {\n    border: 2px solid #1d4ed8;\n    border-radius: 6px;\n}\n\n.example-full-width {\n    width: 100%;\n}\n\n.add-pathways-container {\n    height: 82%;\n    width: 460px;\n    position: fixed;\n    z-index: 99;\n    top: 70px;\n    right: 5px;\n}\n\n.add-pathways-container .path-img {\n    border-radius: 13px;\n    max-height: 250px;\n    width: 100%;\n}\n\n.civ-message .msg-description {\n    overflow-wrap: anywhere;\n}\n\n.civ-message-body {\n    display: flex;\n}\n\n.civ-message-body.from {\n    justify-content: flex-start;\n}\n\n.civ-message-body.to {\n    justify-content: flex-end;\n}\n\n.civ-message {\n    display: inline-block;\n    border-radius: 1.5rem;\n    margin-bottom: 15px;\n    padding: 8px 20px;\n    position: relative;\n    /*font-size: 20px;*/\n}\n\n.civ-message-body.to .civ-message {\n    background-color: #9b4dca;\n    color: #fff;\n    margin-left: 100px;\n    width: 200px;\n}\n\n.civ-message .type-image {\n    width: 100px;\n}\n\n.civ-message-body.from .civ-message {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n}\n\n.civ-message-body.to+.civ-message-body.to,\n.civ-message-body.from+.civ-message-body.from {\n    margin-top: -10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion .list-group {}\n\n.civ-message-suggestion .list-group-item {\n    padding: 0.5rem;\n}\n\n.civ-message-suggestion .choice {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n\n.objectImg img {\n    height: 40px;\n}\n\n.objectImg span i {\n    font-size: 18px;\n    cursor: pointer;\n    color: #6c6c6c;\n}\n\n.civ-message .type-image {\n    width: 100px;\n}\n\n.civ-message .msg-description {\n    overflow-wrap: anywhere;\n}\n\n.objectives {\n    width: 300px;\n    position: relative;\n    margin: 11px 0 0 0;\n}\n\n.objectives input {\n    margin: 0px;\n    padding: 0px;\n    width: 100%;\n    outline: none;\n    height: 40px;\n    border-radius: 5px;\n    border: none;\n    padding: 0 0 0 5px;\n}\n\n.objectives button {\n    position: absolute;\n    top: 0;\n    right: -2px;\n    z-index: 2;\n    border: none;\n    top: 0;\n    height: 40px;\n    cursor: pointer;\n    transform: translateX(2px);\n    width: 36px;\n}\n\n.objectives i {\n    font-size: 18px;\n    line-height: 2;\n    color: #6c6c6c;\n}\n\n.objectImg img {\n    height: 40px;\n}\n\n.objectImg span i {\n    font-size: 18px;\n    cursor: pointer;\n    color: #6c6c6c;\n}\n\n.objectivesButtons .btnDone {\n    background: #9b4dca;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.objectivesButtons .btnCancel {\n    background: #6c6c6c;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.show-objectives {\n    width: 100%;\n    height: 40px;\n    position: relative;\n    margin: 11px 0 0 0;\n    background-color: white;\n    color: #6c6c6c;\n    overflow-wrap: anywhere;\n    overflow: auto;\n    padding: 0 5px;\n}\n\n.objectivesButtons .btnDone {\n    background: #9b4dca;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.objectivesButtons .btnCancel {\n    background: #6c6c6c;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n    margin-left: 5px;\n}\n\n.pathways-colors {\n    margin: 0px 5px 10px;\n    width: 60px;\n    height: 30px;\n    border-radius: 10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion .list-group {}\n\n.civ-message-suggestion .list-group-item {\n    padding: 0.5rem;\n}\n\n.civ-message-suggestion .choice {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n\n.civ-message-suggestion .list-group {}\n\n.civ-message-suggestion .list-group-item {\n    padding: 0.5rem;\n}\n\n.civ-paths-btn {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(100, 56, 180, 0.05);\n    border: 1px solid #6438B4;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #6438B4;\n    padding: 0 16px;\n    margin: 5px;\n    min-height: 50px;\n    position: relative;\n}\n\n.civ-paths-btn i {\n    display: none;\n    cursor: pointer;\n    margin-right: -5px;\n    margin-left: 5px;\n}\n\n.civ-paths-btn:hover i {\n    display: inline-block;\n}\n\n.popup-objective {\n    z-index: 1;\n    position: absolute;\n    background: white;\n    padding: 0 7px;\n    border-radius: 6px;\n    width: fit-content;\n    top: 52px;\n    right: 0;\n    width: 200px;\n    height: 210px;\n    overflow: auto;\n}\n\n.objective-img {\n    height: 48px;\n    display: flex;\n    align-items: center;\n    width: fit-content;\n}\n\n.popup-objective ul {\n    text-align: start;\n    padding-left: 25px;\n}\n\n.popup-objective li {\n    margin-top: 10px;\n}\n\n::ng-deep #node .active {\n    fill: #ffb46e !important;\n}\n\n.contibutorsTabs p {\n    margin: 0;\n    font-size: 17px;\n    cursor: pointer\n}\n\n.activeTab {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.sharing-modal-body {\n    padding: 15px;\n}\n\n.collabeBody {\n    height: 325px !important;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n.sharing-links {\n    list-style-type: none;\n    padding: 0;\n    text-align: center;\n    /* margin-top: 40px; */\n    margin-bottom: 40px;\n}\n\n.sharing-links li {\n    display: inline-block;\n    margin-right: 40px;\n    cursor: pointer;\n}\n\n.user-list-item {\n    width: 100%;\n    text-align: left;\n    margin-right: 30px;\n}\n\n.sharing-links li img {\n    width: 50px;\n    height: 50px;\n}\n\n.sharing-links li p {\n    font-size: 12px;\n    color: #a6a3a3;\n}\n\n.follower-name {\n    margin-left: 10px;\n}\n\n.collabeImg {\n    border-radius: 7px;\n    width: 30px !important;\n    height: 30px !important;\n    margin-right: 4px;\n    margin-top: -7px;\n}\n\n.custom-footer button.modal-btn {\n    background-color: #6e5eff;\n    color: #fff;\n    border-radius: 4px;\n    padding: 5px 15px;\n}\n\n.custom-footer button.modal-btn-close {\n    background-color: #605f5f;\n    color: #fff;\n    border-radius: 4px;\n    padding: 10px 23px;\n}\n\n.node-context-menu .menu-item {\n    font-size: 12px;\n}\n\n.tree-Modal .tree-card-content .vid-select select {\n    width: 100%;\n    border-bottom: 1px solid #5c5c5c;\n    border-radius: 0;\n    margin-bottom: 10px;\n    font-size: 15px;\n}\n\n.tree-Modal .tree-card-content .opts-row button img {\n    width: 20px;\n    height: 20px;\n}\n\n.tree-Modal .tree-card-vid .leave-btn,\n.tree-Modal .tree-card-vid .more-btn {\n    position: absolute;\n    top: 8px;\n    z-index: 99;\n}\n.more-btn .dropdown-menu {\n    min-width: auto;\n}\n/*.video-card {*/\n/*  cursor: pointer;*/\n/*}*/\n\n.tree-Modal .tree-card-vid .leave-btn {\n    left: 14px;\n    color: #ffffff;\n    opacity: 1;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.tree-Modal .tree-card-vid .more-btn {\n    right: 8px;\n}\n\n.tree-Modal .tree-card-content .check-line span {\n    width: 20px;\n    height: 20px;\n    border: 1px solid black;\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.tree-Modal .tree-card-content .check-line input {\n    color: #000;\n    margin-left: 10px;\n    border: 0px;\n    width: 6vw;\n    border-bottom: 1px solid #ccc;\n    font: 400 14px/20px Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.tree-Modal .tree-card-content .check-line label {\n    cursor: pointer;\n    font-size: 15px;\n}\n\n.tree-Modal .tree-card-content .check-line input:checked+label:after {\n    content: \"\";\n    position: absolute;\n    left: 22px;\n    top: 5px;\n    width: 6px;\n    height: 14px;\n    border: solid #6e5eff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.tree-Modal .tree-card-vid video {\n    outline: none;\n}\n\n.close {\n    font-weight: normal !important;\n}\n\n.tree-Modal .tree-card-vid .leave-btn,\n.tree-Modal .tree-card-vid .more-btn {\n    position: absolute;\n    top: 8px;\n    z-index: 99;\n}\n\n.tree-Modal .tree-card-vid .leave-btn {\n    left: 14px;\n    color: #ffffff;\n    opacity: 1;\n    font-weight: 400;\n    font-size: 16px;\n}\n\ninput.close.leave-btn {\n    background: transparent;\n    border: none;\n    padding-bottom: 5px;\n    border-bottom: 1px solid #ccc;\n    text-align: center;\n    width: 100%;\n    margin-left: 0px;\n}\n\n.title-center {\n    float: none;\n    margin-left: 90px;\n}\n\n.preview-image-none {\n    font-size: 22px;\n    background: #e1e1e1;\n    height: 300px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.preview-image {\n    width: 100%;\n    height: auto;\n    max-height: 300px;\n    cursor: pointer;\n    object-fit: contain;\n}\n\n.chcoice {\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.add-choices input {\n    width: 60px;\n    display: inline-block;\n}\n\n.addChoiceDropDown .dropdown-menu {\n    min-width: 8.2rem;\n    padding: 0 !important;\n}\n\n.addChoiceDropDown .dropdown-menu .dropdown-item {\n    font-size: 14px;\n}\n\n.addChoiceDropDown .dropdown-item:focus,\n.addChoiceDropDown .dropdown-item:hover {\n    background-color: rgb(241 234 254) !important;\n    color: #6c2fbb !important;\n}\n\n.addChoiceDropDown .dropdown-item.active,\n.addChoiceDropDown .dropdown-item:active {\n    background-color: inherit;\n    color: inherit;\n}\n\n.choice-btn {\n    border: 1px solid #6e5eff;\n    padding: 5px 15px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    border-left: 0;\n    height: fit-content;\n    /* margin: 0 0px 0 4px; */\n    /* max-width: 99.2% !important; */\n}\n\n.dropdown-menus {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n}\n\n.dropdown-menu ul {\n    list-style: none;\n    padding-left: 0px;\n}\n\n.dropdown-menu ul li {\n    border-bottom: 1px solid #80808094;\n    padding-left: 11px;\n    margin-top: 7px;\n    color: #605f5f;\n    font-size: 12px;\n}\n\n.dropdown-menu .form-control {\n    margin-top: 11px;\n    border-radius: 0;\n    padding: 5px;\n    outline: none;\n}\n\n.dropdown-menu {\n    min-width: 22.4rem;\n    top: -277px;\n}\n\n.dropdown-menu [type=\"checkbox\"] {\n    width: 35px;\n    height: 15px;\n}\n\n.addChoiceDropDown .dropdown-menu {\n    min-width: 8.2rem;\n    padding: 0 !important;\n}\n\n.addChoiceDropDown .dropdown-menu .dropdown-item {\n    font-size: 14px;\n}\n\n.chexk-box-top {\n    width: 100%;\n    margin: 5px;\n}\n\n.userPromptSection {\n    padding-right: 25px;\n    padding-left: 5px;\n}\n\n.userPromptSection input {\n    border-bottom: 1px solid #cccccc !important;\n}\n\n.nodeTitleInput {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    outline: none;\n    padding-bottom: 5px;\n    width: 100%;\n}\n\n.nodeTitleInput:focus {\n    border-bottom: 1px solid #ccc;\n}\n\n.dropdownWidth {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n}\n\n.option-choices {\n    margin-bottom: 15px;\n}\n\n.option-choices.draggable {\n    cursor: move;\n    border: 1px dashed #dc3545;\n}\n\n.nodeTitleInput {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    outline: none;\n    padding-bottom: 5px;\n    width: 100%;\n}\n\n.nodeTitleInput:focus {\n    border-bottom: 1px solid #ccc;\n}\n\n.find-peoples-sec .search-area .share-btn {\n    width: 100%;\n    background: #6e5eff;\n    color: #ffffff;\n}\n\n.find-peoples-sec .search-area .search button {\n    position: absolute;\n}\n\n.find-peoples-sec .search-area .search input {\n    padding-left: 40px;\n    font-size: 15px;\n}\n\n.find-peoples-sec .select-area .FF-scroll-modify {\n    height: 133px;\n}\n\n.find-peoples-sec .select-area .form-check {\n    margin-bottom: 14px;\n}\n\n.find-peoples-sec .select-area .form-check span {\n    display: inline-block;\n    width: 35px;\n    height: 35px;\n    border: 1px solid #e6e3e3;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.find-peoples-sec .select-area .form-check input {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n    margin-left: 0px;\n}\n\n.find-peoples-sec .select-area .form-check span img {\n    width: 100%;\n    height: 100%;\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label {\n    color: #6e5eff;\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label:after {\n    content: \"\";\n    position: absolute;\n    left: 13px;\n    top: 8px;\n    width: 10px;\n    height: 17px;\n    border: solid #ffffff;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label:before {\n    content: \"\";\n    width: 35px;\n    height: 35px;\n    background-color: #6e5effcc;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    border-radius: 50%;\n}\n\n.find-peoples-sec .search-area h6.count-selected {\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 0px;\n    color: #919191;\n}\n\n.w-qus {\n    width: 3.2rem;\n    height: 3.2rem;\n}\n\n.timer-button {\n    background: #6e5eff;\n    border-color: #6e5eff;\n    color: white;\n    padding: 8px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.create-interactive-button {\n    border: 1px solid #6e5eff;\n    padding: 8px 30px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    font-size: 15px;\n    display: block;\n    /*margin: 0 auto;*/\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    margin: 4px 0 4px 4px;\n}\n\n/* ::ng-deep .nodeImage {\n    width: 182px;\n    height: 130px;\n} */\n\n\n.tree-share-Modal,\n.tree-preview-vid-Modal,\n.tree-publish-vid-Modal {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n}\n\n.tree-share-Modal .modal-body,\n.tree-share-Modal .modal-header,\n.tree-preview-vid-Modal .modal-body,\n.tree-preview-vid-Modal .modal-header,\n.tree-publish-vid-Modal .modal-body,\n.tree-publish-vid-Modal .modal-header {\n    padding: 20px 25px 25px 25px;\n}\n\n.tree-share-Modal .modal-title,\n.tree-preview-vid-Modal .modal-title,\n.tree-publish-vid-Modal .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group {\n    position: relative;\n    margin-bottom: 15px;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) label {\n    top: 5px;\n    left: 0;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) textarea {\n    padding: 15px 10px 10px 10px;\n    height: 150px;\n    resize: none;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec h5 {\n    font-size: 17px;\n    margin-bottom: 0px;\n    margin-top: 1rem;\n}\n\n.mat-hint {\n    font-size: 0.7rem;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec p {\n    font-size: 12px;\n    color: #605f5f;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec select {\n    font-size: 14px;\n}\n\n.publish-vid-sec .info-radio .select-radio {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 15px;\n}\n\n.publish-vid-sec .info-radio .select-radio input {\n    opacity: 0;\n}\n\n.publish-vid-sec .info-radio .select-radio .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 22px;\n    width: 22px;\n    border: 1px solid black;\n    border-radius: 50%;\n}\n\n.publish-vid-sec .info-radio .select-radio input:checked+.checkmark:before {\n    content: \"\";\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    height: 10px;\n    width: 10px;\n    background-color: #6e5eff;\n    border-radius: 50%;\n}\n\n.find-peoples-sec .search-area h6.count-selected {\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 0px;\n    color: #919191;\n}\n\n/* Tree chart select & share Modal */\n\n/* Tree Chart video preview Modal */\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {\n    font-size: 17px;\n    margin-bottom: 0px;\n    margin-top: 1rem;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt>.row {\n    align-items: center;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {\n    font-size: 15px;\n    color: black;\n    padding: 8px 0px;\n    border-radius: 6px;\n    transition: all 0.2s linear;\n    width: 150px;\n    border: 1px solid #ccc;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {\n    background-color: #6e5eff;\n    color: #ffffff;\n}\n\n.optionsOFchoice {\n    background: #000;\n    z-index: 9;\n    position: relative;\n    display: table;\n    width: 100%;\n    text-align: center;\n}\n\n.optionschoiceitem {\n    padding: 20px 10px;\n    font-size: 16px;\n    /* border-radius: 5px; */\n    color: #fff;\n    /* margin-right: 10px; */\n    /* margin-bottom: 10px; */\n    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);\n    cursor: pointer;\n    border-right: 1px solid #fff;\n    display: table-cell;\n    word-break: break-all;\n}\n\n.optionschoiceitem:hover {\n    color: #726bfa;\n}\n\n/* Connector Node Link Definition */\n/*::ng-deep .link {\n    fill: auto !important; \n    stroke: red !important;\n    stroke-width: 2px;\n}*/\n\n::ng-deep .link {\n    fill: auto;\n    /* Allow fill inheritance */\n    stroke: red;\n    stroke-width: 2px;\n}\n\n.publish-vid .thumbnail-area .row>div {\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.publish-vid .thumbnail-area .select-thumb {\n    position: relative;\n    cursor: pointer;\n    height: 60px;\n    margin-top: 10px;\n}\n\n.publish-vid .thumbnail-area .select-thumb.up {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px dotted;\n}\n\n.publish-vid .thumbnail-area .select-thumb input {\n    display: none;\n}\n\n.publish-vid .thumbnail-area .select-thumb .upload img {\n    width: 20px;\n    height: 20px;\n}\n\n.publish-vid .thumbnail-area .select-thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.publish-vid .thumbnail-area .select-thumb input:checked~.check {\n    width: 100%;\n    height: 100%;\n    background-color: #6e5effcc;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.publish-vid .thumbnail-area .select-thumb input:checked~.check:before {\n    content: \"\";\n    width: 7px;\n    height: 14px;\n    border: solid #ffffff;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n}\n\n.publish-vid .thumbnail-area .select-thumb img.deletrThumnails {\n    width: 30px;\n    height: auto;\n    /* margin-top: -43px; */\n    text-align: center;\n    margin-top: 5px;\n    padding: 5px;\n}\n\n.publish-vid .thumbnail-area .select-thumb img.deletrThumnails:hover {\n    background: #ccc;\n}\n\n.publish-vid-btn {\n    bottom: 0px;\n    right: 16px;\n}\n\n.publish-vid-btn button {\n    font-size: 15px;\n    color: black;\n    padding: 8px 0px;\n    border-radius: 6px;\n    transition: all 0.2s linear;\n    width: 140px;\n    border: 1px solid #ccc;\n    background-color: #6e5eff;\n    color: #ffffff;\n}\n\n.newContentTree {\n    background: #6c2fbbb8;\n    color: white;\n    padding: 10px 20px;\n}\n\n.newContentTree .btn-close {\n    filter: brightness(0) invert(1);\n    box-shadow: none;\n    opacity: 1;\n    padding: 0;\n}\n\n.newContentTree .info-img {\n    filter: brightness(0) invert(1);\n    margin-top: 8px;\n}\n\n.newContentTree h6 {\n    font-size: 15px;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.newContentTree .btn-light {\n    font-size: 14px;\n    padding: 4px 8px;\n}\n\n.newContentTree a {\n    text-decoration: underline;\n    color: white\n}\n\n.newContentTree p {\n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.updateAiKeyInsightsDialog label {\n    font-size: 15px;\n}\n\n.key-insight-group {\n    border-bottom: 1px solid #e5e5e5;\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n}\n\n.key-insight-box {\n    background: rgb(108 47 187 / 10%);\n    padding: 15px 10px;\n    border-radius: 8px;\n    position: relative;\n}\n\n.remove-category {\n    width: 25px;\n    height: 25px;\n    background-color: #e85959;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.visibility-switch .form-check-input {\n    box-shadow: none;\n    width: 50px;\n    height: 25px;\n    margin: 0;\n    cursor: pointer;\n    border-color: #6c2fbb !important;\n    background-image: url('../../../../../assets/images/switch-focus.svg') !important;\n}\n\n.visibility-switch .form-check-input:checked {\n    background-color: #6c2fbb;\n    background-image: url('../../../../../assets/images/switch-check.svg') !important;\n}\n\n/* < !-- PS Changes --> */\n.btnKeyInsight {\n    filter: brightness(0) invert(1);\n}\n\n.btnEditIcon {\n    border: 1px solid #f8f9fa;\n    height: 32px\n}\n.choiceNameInput{\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    padding-bottom: 5px;\n    width: 100%;\n}\n\n.choiceNameInput:focus {\n    border-bottom: 1px solid #ccc;\n    border-radius: 0;\n}\n\n::ng-deep .my-dialog-edit {\n    justify-content: center;\n}\n\n::ng-deep .my-dialog-edit .mdc-dialog__container {\n    margin: auto;\n}\n\n::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {\n    visibility: hidden;\n}\n\n.choice-bulb {\n    background-color: #7a2df9;\n    width: 26px;\n    height: 26px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.choices-box {\n    box-shadow: 0 0 7px 2px rgba(0, 0, 0, 0.07);\n    padding: 10px 15px;\n    border-radius: 10px;\n}\n\n.bulkEditBtn{\n    width: 220px !important;\n}\n.bulkChoiceModel .modal-content {\n    position: relative;\n}\n.bulkChoiceModel .modal-content::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.5);\n}\n\n#suggest-choice-name-modal .choices-box p {\n    font-size: 15px;\n}\n#suggest-choice-name-modal .active {\n    background: rgba(122, 45, 249, 0.1);\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n}\n\n.aiSuggestion{\n    display: inline-block;\n}\n.videoNameCls{\n    margin-bottom: 0 !important;\n}\n\n.close-purple {\n    display: flex;\n    margin-right: 4px;\n}\n.close-purple .btn-close {\n    opacity: 1;\n    background-size: 10px;\n}\n\n.bottom-action {\n    width: 35px;\n    height: 35px;\n    border-radius: 100%;\n    /* background-color: #6c2fbb; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    bottom: 25px;\n    right: 64px;\n    cursor: pointer;\n    z-index: 9;\n}\n.bottom-action img {\n    transition: all 0.2s;\n    filter: brightness(0);\n}\n.bottom-action.hide-section img {\n    rotate: 180deg;\n    filter: unset;\n}\n\n.hide-section-minimap{\n    rotate: 180deg;\n    filter: unset;\n}\n\n@media (max-width: 1034px) {\n    .tree-Modal .tree-card-content .check-line input {\n        width: 20vw;\n    }\n}\n\n@media (max-width: 565px) {\n    .tree-Modal .tree-card-content .userPromptSection>div:first-child {\n        flex-direction: column;\n        gap: 0 !important;\n        margin-bottom: 10px;\n        margin-top: 5px;\n        font-size: 15px;\n    }\n\n    .tree-Modal .tree-card-content .userPromptSection>div:last-child i {\n        vertical-align: bottom;\n    }\n}\n\n@media (max-width: 576px) {\n    .vid-options {\n        margin-top: 10px !important;\n    }\n\n    .dropdown-menu {\n        min-width: 15.4rem !important;\n    }\n}\n\n@media (max-width: 991px) {\n    section.vid-publish-footer {\n        padding-block: 8px !important;\n    }\n    .tree-view-chart-sec {\n        padding: 0px 26px !important;\n    }\n\n    .select-video {\n        width: auto !important;\n        padding: 20px !important;\n    }\n\n    .uploadVideoButton {\n        width: auto !important;\n        padding: 20px !important;\n    }\n\n    .dropdown-menu {\n        min-width: 15.4rem !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .bottom-action {\n        bottom: 82px;\n        right: 35px;\n    }\n    .vid-publish-footer .row .footer-text {\n        margin-bottom: 0 !important;\n    }\n}\n@media (max-width: 434px) {\n    .tree-Modal .tree-card-content .chexk-box-top label {\n        width: 100%;\n        margin-bottom: 6px !important;\n        font-size: 15px;\n    }\n\n    .tree-Modal .tree-card-content .mat-card-title-group .mat-card-sm-image {\n        width: 50px;\n        height: 50px;\n    }\n\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleChoice {\n        padding-left: 7px !important;\n    }\n\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleEdit,\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleUpload {\n        padding-inline: 0 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
